export default __webpack_public_path__ + "media/Fisheye_tablet.cd540ede06e03f531f6c371ba6d1093f.svg";